import type { components } from '~/types/napis'
import type { Temp_TestQuestion, Temp_TestUserAnswerInput } from './tempTestQuestions'

export type Temp_AssessmentType = 'SKILL' | 'APPLICATION' | 'COURSE' | 'JOB'

export type Temp_TestQuestionType =
  | 'MCQ_ONE'
  | 'MCQ_MULTIPLE'
  | 'LIVE_CODING'
  | 'PROJECT'
  | 'SHORT_QUESTION'

export type SkillsStatus = components['schemas']['InterviewStatus']

export type SkillsReadableStatus =
  | 'FAILED_RESUMABLE'
  | 'FAILED_EXPIRED'
  | 'COMPLETED'
  | 'ABANDONED'
  | 'IN_PROGRESS'
  | 'SCHEDULED_AVAILABLE'
  | 'SCHEDULED_PENDING'
  | 'SCHEDULED_EXPIRED'

export type Temp_TestGroup = {
  id_slug: string
  created_date: string
  // basic info, for cards, or categorization
  title: string
  total_questions: number
  test_type: Temp_AssessmentType
  question_type: Temp_TestQuestionType[]
  // question part
  questions_id_slugs: string[]
  questions_part: Temp_TestQuestion[]
  // browser proctor
  has_browser_proctor: boolean // if true, then user not allowed change browsers
  // time limit
  time_limit_minutes: number | null
  time_limit_unlimited: boolean
  // result
  allow_show_result: boolean // default true
  result_available_date?: string | null
  // test-related info to show users, at specific pages
  description?: string | null
  topics?: string | null
  instructions?: string[] | null
  disclaimers?: string[] | null
  complete_messages?: string[] | null
  error_messages?: string[] | null
  // other parts
  admin_part?: null
  company_part?: null
  company_title?: string | null
  job_title?: string | null
}

// test session
export type Temp_SkillsTest = {
  id_slug: string
  created_date: string
  test_group: Temp_TestGroup
  answered_questions: number | null // question that student has answered
  // allowed access time
  allow_open_always: boolean
  allow_start_datetime: string | null
  allow_end_datetime: string | null
  // user access
  start_datetime: string | null
  end_datetime: string | null
  // status
  status: SkillsStatus
  readable_status: SkillsReadableStatus
  // user answer part
  answer_id_slugs?: string[] | null // link to Temp_TestUserAnswer
  user_answers_part?: Temp_TestUserAnswerInput[] | null
  // result part - no need to show all the time
  result_part: { result: number } | null
  // error
  error_part: {
    error_message: string
    resolved: boolean
  } | null
  user_part?: null | {
    email: string
    first_name: string
    last_name: string
    id_slug: string
  }
}

export const testTermsAndConditions = [
  'This test is used to evaluate your suitability for the role or course applied.',
  'You agree not to share or distribute any part of the test content.',
  'All answers must be your own work without unauthorised help.',
  'The test must be completed within the given time limit.',
  'Your responses will be used for evaluation and stored securely.',
  'All test content is the intellectual property of the organisation.',
  'Any breach of these terms may result in disqualification.',
  'You are responsible for ensuring your device and internet work properly.',
  'Completing the test does not guarantee selection.',
  'By starting the test, you confirm that you accept these terms.'
]
